import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import DriveEndType from "../../enums/drive-end-type";
import { isSeriesOvertime } from "../../utils/overtime-utils";

export default class PeriodStart extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.StartPeriod;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.startPeriod();
        gameContext.gameClock.setSeconds(fragment.periodLengthInSeconds);
        gameContext.gameClock.setLimitSeconds(fragment.periodLengthInSeconds);
        gameContext.triggerSwapTeams = true;
        gameContext.triggerNewPeriodNotification = true;

        const startOfSecondHalf = gameContext.isStartOfSecondHalf(
            fragment.period
        );
        if (startOfSecondHalf) {
            gameContext.toggleSecondHalfPossession();
            gameContext.setDriveContext({
                previousDriveEndType: DriveEndType.Halftime
            });
        }

        const otPeriod = gameContext.getOvertimePeriod();
        const seriesOvertime = isSeriesOvertime(gameContext);
        if (otPeriod) {
            gameContext.setOvertimeNotification({
                period: otPeriod,
                notified: false
            });
            // Series overtime opens every period without a kickoff. With OT
            // Kickoffs on (PSTATS-1268) only the first does, because its toss
            // arms a new one; later periods carry over like a new quarter,
            // an armed kickoff included.
            if (seriesOvertime || otPeriod === 1) {
                gameContext.triggerKO = false;
            }
            gameContext.fbOtDisabled =
                !gameContext.gameConfig.general.otTimeControl;
            // An untimed overtime shows no clock, so a running clock stays
            // paused there rather than time plays nobody sees (PSTATS-1268).
            if (gameContext.fbOtDisabled) {
                gameContext.gameClock.pause();
            }
            if (otPeriod === 1) {
                gameContext.setCoinTossRequired(true);
            }
        }

        if (startOfSecondHalf || seriesOvertime) {
            ruleContext.setResetField(true);
        }
    }
}
